module.exports = __webpack_public_path__ + "img/bens-field-skinny.392530ea.jpg";